import http from '../../utils/fetch';
import updownfile from '../../utils/updownfile';
import shareModel from "../../views/chanp/shareModel";
import fetch from "../../utils/fetch";
export default {

    allvw:'/api/swyl/v1/allmaterialvw/viewMaterialAllvw',

    marcon:'/api/swyl/v1/material/manager/Material',

    //������������
    delivery:'/api/swyl/v1/order/bscOrderProductDeliveryday',

    vwdingjia:'/api/swyl/v1/vwdingjialist/viewMaterialDingjialist',

    faqidingjia:'/api/swyl/v1/material/manager/Material',

    peizhixiang:'/api/swyl/v1/agentconfig/mdmHrswylHmFndValues',

    dingjia:'/api/swyl/v1/price/mdmMaterialInfoPrice',

    miaoshuliandong:'/api/swyl/v1/miaoshuliandong/viewMaterialMiaoshuliandong',

    xiaoshouyangbiao:'/api/swyl/v1/salesamplelist/bscSalesSamplelist',

    quanxuanQuyu:'/api/swyl/v1/xiaoshouquanxuanquyu/xiaoshouQuanxuanQuyu',

    bscrole:"/api/swyl/v1/basic/bscRole",

    proleibie:"/api/swyl/v1/productlevel/productLevel",

    mdmWuliao:"/api/swyl/v1/mtlinfo/mdmHrswylYlMtlInfo",

    dingjiaData:'/api/swyl/v1/price/mdmMaterialInfoPriceData',

    shareModel:'/api/swyl/v1/demo/bscsharemodel',

    caiwuExchange:'/api/swyl/v1/price/caiwuExchange',

    fwMaterialCompare:"/api/swyl/v1/materialCompare",

    eanNotifyUser:'/api/swyl/v1/demo/bscEanNotifyUser',

    selectLeibie(q){
        return http({
            url: this.proleibie + '/getAllId',
            method: 'post',
            params: q
        });
    },
    selectMdmWuliao(q) {
           return http({
            url: this.mdmWuliao + '/selectListByLeiBie',
            method: 'post',
            params: q
        });
    },
    selectListByCode(q){
        return http({
            url: this.mdmWuliao + '/selectListByCode',
            method: 'post',
            params: q
        });
    },


    bscrolelist(q){
        return http({
            url: this.bscrole + '/selectList',
            method: 'post',
            params: q
        });
    },
    updateServiceType(q){
        return http({
            url: this.mdmWuliao + '/updateServiceType',
            method: 'post',
            params: q
        });
    },

    selectByjiaosecode(q){
        return http({
            url: this.quanxuanQuyu + '/selectByjiaosecode',
            method: 'post',
            params: q
        });
    },

    saveorupdatein(q){
        return http({
            url: this.quanxuanQuyu + '/saveorupdatein',
            method: 'post',
            params: q
        });
    },


    quanxuanQuyuselectPage(q){
        return http({
            url: this.quanxuanQuyu + '/selectPage',
            method: 'post',
            params: q
        });
    },


    huoquguanxikexuan(q){
        return http({
            url: this.quanxuanQuyu + '/huoquguanxi',
            method: 'post',
            params: q
        });
    },


    dingjialuojishanchu(q){
        return http.post(
            this.dingjia + '/luojishanchu',q);
    },

    chongxintijiaodingjia(q){
        return http.post(
            this.faqidingjia + '/chongxintijiaodingjia',q);
    },

    gengxinbohuidingjia(q){
        return http.post(
            this.faqidingjia + '/gengxinbohuidingjia',q);
    },

    dingjiaselectPage(q){
        return http({
            url: this.dingjia + '/selectPage',
            method: 'post',
            params: q
        });
    },

    dingjiaselecthistroyPage(q){
        return http({
            url: this.dingjia + '/selecthistroyPage',
            method: 'post',
            params: q
        });
    },

    selectAll(q){
        return http({
            url: this.dingjia + '/selectAll',
            method: 'post',
            params: q
        });
    },
    selectAllBymCodes(q){
        return http({
            url: this.dingjia + '/selectAllBymCodes',
            method: 'post',
            params: q
        });
    },
    selectProPrice(productId){
        return http({
            url: this.dingjia + '/selectProPrice',
            method: 'post',
            params: {productId}
        });
    },

    selectPriceData(materialCode){
        return http({
            url: this.dingjiaData + '/selectPriceData',
            method: 'post',
            params: {materialCode}
        });
    },


    chazhaobohuidingjia(q){
        return http({
            url: this.faqidingjia + '/chazhaobohuidingjia',
            method: 'post',
            params: q
        });
    },

    downloadExcelByIds(c){

        updownfile.down(this.dingjia+'/downloadExcelByIds',c,"post",'data');

        //window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCompetitorsForExcel?companyName='+companyName+'&cdate='+cdate

    },
    downloadHistorExcelByIds(c){

        updownfile.down(this.dingjia+'/downloadHistoriExcelByIds',c,"post",'data');

        //window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCompetitorsForExcel?companyName='+companyName+'&cdate='+cdate

    },
    downloadHistorallExcelByIds(c){
        updownfile.down(this.dingjia+'/downloadHistorallExcelByIds',c,"post",'data');
    },

    selectProList(query) {
        return http({
            url: this.allvw + '/selectProList',
            method: 'post',
            data: query
        });
    },

    selectPage(q){
        return http({
            url: this.allvw + '/selectPage',
            method: 'post',
            params: q
        });
    },

    havmarselectPage(q){
        return http({
            url: this.allvw + '/havmarselectPage',
            method: 'post',
            params: q
        });
    },
    havmarselect3QPage(q){
        return http({
            url: this.allvw + '/havmarselect3QPage',
            method: 'post',
            params: q
        });
    },
    //������Ʒά��ҳ�� ���б��ҳ��ѯ
    orderSendTypeNlectPage(q){
        return http({
            url: '/api/swyl/v1/demo/orderSendTypeN/selectpage',
            method: 'post',
            params: q
        });
    },
    //������Ʒά��ҳ�� ����
    insertSendTypeN(q){
        return http({
            url: '/api/swyl/v1/demo/orderSendTypeN/insertSendTypeN',
            method: 'post',
            params: q
        });
    },
    //������Ʒά��ҳ�� �޸�
    updateSendTypeN(q){
        return http({
            url: '/api/swyl/v1/demo/orderSendTypeN/updateSendTypeN',
            method: 'post',
            params: q
        });
    },
    //������Ʒ ������Ʒģ����ѯ
    selectNewProduct(q){
        return http({
            url: '/api/swyl/v1/demo/orderSendTypeN/getMaterialByCode?productCode=' + q,
            method: 'post',
            params: q
        });
    },



    vwdingjiaselectList(q){
        return http({
            url: this.vwdingjia + '/vwdingjiaselectList',
            method: 'post',
            params: q
        });
    },

    havmardownloadExcel(c){

        updownfile.down(this.allvw+'/havmardownloadExcel',c,"post",'data');

        //window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCompetitorsForExcel?companyName='+companyName+'&cdate='+cdate

    },

    havmar3QdownloadExcel(c){

        updownfile.down(this.allvw+'/havmar3QdownloadExcel',c,"post",'data');

        //window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCompetitorsForExcel?companyName='+companyName+'&cdate='+cdate

    },

    peizhiselectList(q){
        return http.post(
            this.peizhixiang + '/getconfig',q);
    },


    selectList(){
        return http({
            url: this.allvw + '/selectList',
            method: 'post',
        });
    },


    idselectList(q){
        return http.post(this.xiaoshouyangbiao + '/idselectList', q);
    },
    idselectListAll(q){
        return http.post(this.xiaoshouyangbiao + '/idselectListAll', q);
    },
    chaxunwuliao(q){
        return http.post(this.marcon + '/chaxunwuliaoqingkuang', q);
    },


    findallselldiqu(q){
        return http({
            url: this.marcon + '/findallselldiqu',
            method: 'post',
            params: q
        });
    },


    idaorrowIdbselectList(q){
        return http({
            url: this.allvw + '/idaorrowIdbselectList',
            method: 'post',
            params: q
        });
    },


    gotoSetPrice(q){
        return http({
            url: this.faqidingjia + '/gotoSetPrice',
            method: 'post',
            params: q
        });
    },

    updateData(q){
        return http({
            url: this.faqidingjia + '/updateData',
            method: 'post',
            params: q
        });
    },

    getHistoryMarcode(q){
        return http({
            url: this.faqidingjia + '/getHistoryMarcode',
            method: 'post',
            params: q
        });
    },

    overSetPrice(q){
        return http.post(this.faqidingjia + '/overSetPrice',q);
    },


    dingjiazengjiazancun(q){
        return http({
            url: this.faqidingjia + '/adddingjia',
            method: 'post',
            timeout: 300 * 1000,
            data: q
        });
    },


    xuanzeliucheng(q){
        return http({
            url: this.faqidingjia + '/xuanzeliucheng',
            method: 'post',
            params: q
        });
    },



    downloadExcel(c){

        updownfile.down(this.allvw+'/downloadExcel',c,"post",'data');

        //window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCompetitorsForExcel?companyName='+companyName+'&cdate='+cdate

    },

    downloadExcelNew(c){

        updownfile.down(this.allvw+'/downloadExcelNew',c,"post",'data');

        //window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCompetitorsForExcel?companyName='+companyName+'&cdate='+cdate

    },
    downloadExcelbymodel(c){

        updownfile.down(this.dingjia+'/downloadExcelbymodel',c,"post",'data');

    },

    downloadExcelbyq(c){

        updownfile.down(this.dingjia+'/downloadExcelbyq',c,"post");

    },
    //历史定价的导出接口
    downloadExcelhistorybymodel(c){

        updownfile.down(this.dingjia+'/downloadExcelHistorybymodel',c,"post",'data');

    },
    downloadExcelhistorybyq(c){

        updownfile.down(this.dingjia+'/downloadExcelHistorybyq',c,"post");

    },



    downloadExcelbymodel3Q(c){

        updownfile.down(this.dingjia+'/downloadExcelbymodel3Q',c,"post",'data');

    },

    downloadExcelbyq3Q(c){

        updownfile.down(this.dingjia+'/downloadExcelbyq3Q',c,"post");

    },

    addzancun(q){
        return http({
            url: this.marcon + '/addzancun',
            method: 'post',
            params: q
        });
    },

    addtijiao(q){
        return http({
            url: this.marcon + '/addtijiao',
            method: 'post',
            params: q
        });
    },
    addMdmtijiao(q){
        return http({
            url: this.marcon + '/addMdmtijiao',
            method: 'post',
            params: q
        });
    },
    overzhenwuliaoshenpi(q){
        return http({
            url: this.marcon + '/overzhenwuliaoshenpi',
            method: 'post',
            params: q
        });
    },

    chongxintijiao(q){
        return http({
            url: this.marcon + '/chongxintijiao',
            method: 'post',
            params: q
        });
    },

    ///api/swyl/v1/order/bscOrderProductDeliveryday
    selectDeliveryday(q){
        return http({
            url: this.delivery + '/selectDeliverydayList',
            method: 'post',
            params: q
        });
    },

    //deleteDeliveryday
    deleteDeliveryday(q){
        return http({
            url: this.delivery + '/deleteDeliveryday' ,
            method: 'post',
            params: q
        });
    },
    //����
    insertDeliveryday(q){
        return http({
            url: this.delivery + '/insertDeliveryday' ,
            method: 'post',
            params: q
        });
    },
    // �޸�
    updateDeliveryday(q){
        return http({
            url: this.delivery + '/updateDeliveryday' ,
            method: 'post',
            params: q
        });
    },
    //�����ύ
    ///api/swyl/v1/order/bscOrderProductDeliveryday/startProcess
    startProcess(q){
        return http({
            url: this.delivery + '/reStartProcess' ,
            method: 'post',
            params: q
        });
    },
    //�������
    verifySendAllApi(q) {
        return http.post(this.delivery + '/startProcess',q);
    },
    // ����
    downloadExcelProduct(c){
        updownfile.down(this.delivery+'/downloadExcel',c,"post",'data');
        //window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCompetitorsForExcel?companyName='+companyName+'&cdate='+cdate
    },
    // ��Ʒ��������  ��ѯ��Ϣ
    selectByInstid(q){
        return http({
            url: this.delivery + '/selectByInstid?instid='+ q,
            method: 'post',
            params: q
        });
    },
    ///checkPass  ͨ��
    checkPassPM(q){
        return http.post(this.delivery + '/checkPass',q);
        // return http({
        //     url: this.delivery + '/checkPass',
        //     method: 'post',
        //     params: q
        // });
    },
    // /checkReject ����
    checkRejectPM(q){
        return http.post(this.delivery + '/checkReject',q);
    },
    //��ѯ�����
    selectPageInfo(q){
        return http({
            url: '/api/swyl/v1/demo/bscAccompanyingInstruction/selectInfopage',
            method: 'post',
            params: q
        });
    },
    // ��ѯ ���ɵ������
    selectPageInstruction(q){
        return http({
            url: '/api/swyl/v1/demo/bscAccompanyingInstruction/selectInstructionpage',
            method: 'post',
            params: q
        });
    },
    ///printBarCode �������ӡ
    printBarCode(q){
        // window.open(
        //     "/api/swyl/v1/demo/bscAccompanyingInstruction/printBarCode",q,"post",'data');
            return http({
                responseType: 'arraybuffer',
                url: '/api/swyl/v1/demo/bscAccompanyingInstruction/printBarCode',
                method: 'post',
                params: q
            });
    },
    // ��ӡ����� /printBook
    printProductBook(c){
        return http({
            responseType: 'arraybuffer',
            url: '/api/swyl/v1/demo/bscAccompanyingInstruction/printBook?id='+ c,
            method: 'post',
            //params: c
        });
    },
    printDispatchList(c){
        return http({
            responseType: 'arraybuffer',
            url: '/api/swyl/v1/demo/bscAccompanyingInstruction/printDispatchBill',
            method: 'post',
            params: c
        });
    },

    //���������   /createDeliveryInstruction
    createDeliveryInstruction(q){
        return http.post('/api/swyl/v1/demo/bscAccompanyingInstruction/createDeliveryInstruction',q);
    },
    //����ָʾ��
    eleteDeliverBook(q){
        return http({
            url: '/api/swyl/v1/demo/bscAccompanyingInstruction/revokeOrder' ,
            method: 'post',
            params: q
        });
    },
    //��ѯ����
    searchNumApi(c){
        return http({
            //pi/swyl/v1/order/bscOrderProductDeliveryday/getProduct?productCode=
            url: '/api/swyl/v1/order/bscOrderProductDeliveryday/getProduct?productCode='+ c,
            method: 'post',
            params: c
        })
    },
    // ����
    downloadExcelCommodity(c){
        updownfile.down('/api/swyl/v1/demo/orderSendTypeN/downloadExcel',c,"get",'data');
    },

    //修改市场分类
    changeMarketType(materialCode,marketType){
         return http({
            url:this.dingjia + '/changeMarketType',
            method: 'post',
            params: {"materialCode":materialCode,"marketType":marketType}
        });
    },
    //修改场景分类
    changeSceneType(materialCode,sceneType,sceneName){
        return http({
            url:this.dingjia + '/changeSceneType',
            method: 'post',
            params: {"materialCode":materialCode,"sceneCode":sceneType,"sceneName":sceneName}
        });
    },


    selectShareModel(q){
    return http({
        url: this.shareModel+'/selectpage',
        method: 'post',
        params: q
    });

    },
    insertShareModel(q){
        return http({
            url: this.shareModel+'/insertShareModel',
            method: 'post',
            params: q
        });
    },
    deleteShareModel(q){
        return http({
            url: this.shareModel+'/deleteShareModel',
            method: 'post',
            data: q,

        });
    },

    downloadExcelShareModel(q){
        // updownfile.down(this.shareModel+'/downloadExcel', q,"post",'data');
        return http({
            url: this.shareModel+'/downloadExcel',
            method: 'post',
            data: q,
            responseType: 'blob',
        })
    },
    //校验售后增值服务产品是否维护采购价格
    checkCgprice(q){
        return http({
            url: '/api/swyl/v1/demo/bscSupplierProductCompare/checkCgprice?prodcode=' + q,
            method: 'post',
            params: q
        });
    },
    //产品管制功能
    insertProductControl(q){
        return http({
            url: '/api/swyl/v1/demo/bscProductControl/insertProductControl',
            method: 'post',
            params: q
        });
    },

    //产品管制功能
    updateProductControl(q){
        return http({
            url: '/api/swyl/v1/demo/bscProductControl/updateProductControl',
            method: 'post',
            params: q
        });
    },
    selectProductControlPage(q){
        return http({
            url: '/api/swyl/v1/demo/bscProductControl/selectListPage',
            method: 'post',
            params: q
        });
    },
    deleteList(query) {
        return http({
            url: '/api/swyl/v1/demo/bscProductControl/deleteList',
            method: 'post',
            data: query
        });
    },



    getCaiwuExchangeList(q){
        return http({
            url: this.caiwuExchange+'/selectList',
            method: 'post',
            params: q
        });
    },
    caiwuExchangeSelectById(id){
        return http({
            url: this.caiwuExchange+'/selectById',
            method: 'post',
            params: {id}
        });
    },
    caiwuExchangeDeleteById(id){

        return http({
            url: this.caiwuExchange+'/deleteById',
            method: 'post',
            params: {id}
        });
    },
    caiwuExchangeSaveOrUpdate(q){

        return http({
            url: this.caiwuExchange+'/saveOrUpdate',
            method: 'post',
            params: q
        });
    },
    getSalsePrice(q){
        return http({
            url: '/api/swyl/v1/demo/bscOrderSalsePrice/getPrice',
            method: 'post',
            params: q
        });
    },

    getMdmInfo(q){

        return http({
            url: '/api/swyl/v1/manager/MdmManagerController/saveMdmAll',
            method: 'post',
            params: q
        });
    },

    selectOrderPriceYxListPage(q){
        return http({
            url:'/api/swyl/v1/demo/bscOrderPriceYx/selectOrderPriceYxListPage',
            method: 'post',
            params: q
        });
    },

    selectOrderPriceYxPersonalList(q){
        return http({
            url:'/api/swyl/v1/demo/bscOrderPriceYxPersonal/getBscOrderPriceYxPersonalList',
            method: 'post',
            params: q
        });
    },

    /**
     * 服务公司间产品对照--分页查询
     * @param q
     * @returns {AxiosPromise}
     */
    materailCompareSelectPage(q){
        return http({
            url: this.fwMaterialCompare + '/selectPage',
            method: 'post',
            params: q
        });
    },
    /**
     * 服务公司间产品对照--导出
     * @param q
     * @returns {AxiosPromise}
     */
    materailCompareExport(q){
        return http({
            url: this.fwMaterialCompare + '/downloadExcel',
            method: 'post',
            params: q
        });
    },
    /**
     * 服务公司间产品对照--删除
     * @param id
     * @returns {AxiosPromise}
     */
    materailCompareDeleteById(id){
        return http({
            url: this.fwMaterialCompare+'/deleteMaterialCompare',
            method: 'post',
            params: {id}
        });
    },
    /**
     * 服务公司间产品对照--新增
     * @param q
     * @returns {AxiosPromise}
     */
    materailCompareInsert(q){
        return http({
            url: this.fwMaterialCompare + '/addMaterialCompare',
            method: 'post',
            data: q
        });
    },
    /**
     * 服务公司间产品对照--更新
     * @param q
     * @returns {AxiosPromise}
     */
    materailCompareUpdate(q){
        return http({
            url: this.fwMaterialCompare + '/updateMaterialCompare',
            method: 'post',
            data: q
        });
    },

    // 获取型号?prodcode=
    selectFwProduct(prodcode, fromtype){
        return http({
            url: "/api/swyl/v1/xiaoshouallwuliao/viewXiaoshouyangbiaoAllwuliao/selectFwProduct?prodcode="+prodcode+'&fromtype='+fromtype,
            method: 'post'
        })
    },


    //用户大类维护-分页查询
    selectUserOneL(q){
        return http({
            url: this.eanNotifyUser+'/selectPage',
            method: 'post',
            params: q
        });
    },
    //用户大类维护-新增
    insertUserOneL(q){
        return http({
            url: this.eanNotifyUser+'/insert',
            method: 'post',
            params: q
        });
    },
    //用户大类维护-修改
    updateUserOneL(q){
        return http({
            url: this.eanNotifyUser+'/updateById',
            method: 'post',
            params: q
        });
    },
    //用户大类维护-删除
    deleteUserOneL(q){
        return http({
            url: this.eanNotifyUser+'/deleteById',
            method: 'post',
            params: q
        });
    },


}
